let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lYv4u")).then(() => parcelRequire('1fWHc'));